export const MANUAL_JUDGEMENT_WHEN_OPTIONS = ['manualJudgment', 'manualJudgmentContinue', 'manualJudgmentStop'];

export const PIPELINE_WHEN_OPTIONS = ['pipeline.starting', 'pipeline.complete', 'pipeline.failed'];

export const STAGE_WHEN_OPTIONS = ['stage.starting', 'stage.complete', 'stage.failed'];
